import React from 'react';

const ChapterSpacer = () => (
  <article className="chapter-spacer">_</article>
);

export default ChapterSpacer;
